'use strict'
import axios from 'axios'

if (window.location.hostname == "localhost") {
    axios.defaults.withCredentials = false; //让ajax携带cookie
} else {
    axios.defaults.withCredentials = true; //让ajax携带cookie
}
import qs from 'qs'

import global from '../components/global' //引用全局常量文件
const baseUrl = global.domainName;

//let baseUrl = process.env.API_ROOT;//域名
console.log('baseUrl:', baseUrl);

axios.interceptors.request.use(config => {
    // loading
    return config
}, error => {
    return Promise.reject(error)
})

axios.interceptors.response.use(response => {
    if (response.status === 200) {
        if (response.data.code === '10002' || response.data.code === 10002) {
            // 登录状失效,跳转登录鉴权
            window.location.href = global.doMain + "/index/v1/base/index?from=" + encodeURIComponent(window.location.href);
        }else{
            return response
        }
    } else {
        return Promise.reject(response)
    }
    
}, error => {
    return Promise.resolve(error.response)
})

// function checkStatus (response) {
//   // loading
//   // 如果http状态码正常，则直接返回数据
//   if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
//     return response
//     // 如果不需要除了data之外的数据，可以直接 return response.data
//   }
//   // 异常状态下，把错误信息返回去
//   return {
//     status: -404,
//     msg: '网络异常'
//   }
// }

function checkCode(res, callback) {
    // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
    // if (res.status === -404) {
    //   alert(res.msg)
    // }
    // if (res.data && (!res.data.success)) {
    //   // alert(res.data.error_msg)
    // }
    if (res.code === 403) {

    } else {
        if (typeof callback === 'function') {
            callback(res)
        }
    }
}

export default {
    post(url, data, callback, flag) {
        return axios({
            method: 'post',
            baseURL: flag ? global.doMain : baseUrl,
            url,
            data: qs.stringify(data),

            // timeout: 0,
            headers: { 
                //				      'X-Requested-With': 'XMLHttpRequest',
                //				      'Content-Type': 'application/x-www-form-urlencoded', 
            }
        }).then(
            (res) => {
                if (res && res.data !== undefined) {
                    return checkCode(res.data, callback)
                }
            }
        )
    },
    get(url, params, callback, flag) {
        return axios({
            method: 'get',
            baseURL: flag ? global.doMain : baseUrl,
            url,
            params, // get 请求时带的参数
            // timeout: 0,
            headers: {
                // 'content-type': 'application/json',
                // 'cookie': document.cookie
                // 'X-Requested-With': 'XMLHttpRequest'
            }
        }).then(
            (res) => {
                if (res.data !== undefined) {
                    return checkCode(res.data, callback)
                }
            }
        )
    }
}


// WEBPACK FOOTER //
// ./src/utils/api.js